export default __webpack_public_path__ + "static/jules-undersea-lodge-b4656ac2b4f7dc0615eba24713f0dfe0.jpg";